(() => {
  const toast = document.querySelector('[data-create-toast]');
  let toastTimer;
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-nav]');
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (menu) menu.hidden = open;
    });
  });

  const bindSectionTabs = (buttonSelector, tableSelector) => {
    document.querySelectorAll(buttonSelector).forEach((button) => {
      button.addEventListener('click', () => {
        const section = button.closest('section');
        if (!section) return;
        const active = button.dataset.catalogTab || button.dataset.stackupTab;
        section.querySelectorAll(buttonSelector).forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        section.querySelectorAll(tableSelector).forEach((item) => {
          const group = item.dataset.catalogGroup || item.dataset.stackupTable;
          const selected = group === active;
          if (item.matches('[data-catalog-card]')) item.hidden = !selected;
          else item.classList.toggle('is-active', selected);
        });
        section.querySelector('[data-catalog-rail]')?.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });
  };
  bindSectionTabs('[data-catalog-tab]', '[data-catalog-card]');
  bindSectionTabs('[data-stackup-tab]', '[data-stackup-table]');

  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerItems = drawer?.querySelector('[data-cart-items]');
  const drawerEmpty = drawer?.querySelector('[data-cart-empty]');
  const drawerSubtotal = drawer?.querySelector('[data-drawer-subtotal]');
  const drawerCount = drawer?.querySelector('[data-drawer-count]');
  const money = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)}`;
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const renderDrawer = (cart) => {
    if (!drawer || !drawerItems) return;
    drawerItems.innerHTML = cart.items.map((item) => `<article class="create-drawer-item"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}"><div><strong>${escapeHtml(item.product_title)}</strong><small>${escapeHtml(item.variant_title || '')}</small><label>Qty <input class="create-drawer-item__qty" data-drawer-line="${escapeHtml(item.key)}" type="number" min="0" value="${item.quantity}"></label></div><b>${money(item.final_line_price)}</b></article>`).join('');
    drawerItems.hidden = cart.item_count === 0;
    if (drawerEmpty) drawerEmpty.hidden = cart.item_count !== 0;
    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
    if (drawerCount) drawerCount.textContent = `(${cart.item_count})`;
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
  };
  const refreshCart = async (open = false) => {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    renderDrawer(cart);
    if (open && drawer) { drawer.hidden = false; document.body.classList.add('cart-drawer-open'); }
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', (event) => { event.preventDefault(); refreshCart(true); });
  });
  document.querySelectorAll('[data-cart-close]').forEach((button) => {
    button.addEventListener('click', () => { if (drawer) drawer.hidden = true; document.body.classList.remove('cart-drawer-open'); });
  });
  drawer?.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-drawer-line]');
    if (!input) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: input.dataset.drawerLine, quantity: Number(input.value) }) });
    refreshCart(false);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('[data-gallery-stage]') || gallery.querySelector('.create-product__stage img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!stage) return;
        stage.src = button.dataset.image;
        stage.alt = button.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
        button.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('form.create-product-form').forEach((form) => {
    const picker = form.querySelector('[data-variant-select]');
    const price = form.closest('.create-product__info')?.querySelector('[data-product-price]');
    const comparePrice = form.closest('.create-product__info')?.querySelector('[data-product-compare]');
    const title = form.querySelector('[data-variant-title]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const subscriptionPlan = form.querySelector('[data-subscription-plan]');
    const subscriptionPrice = form.querySelector('[data-subscription-price]');
    const oneTimePrice = form.querySelector('[data-one-time-price]');
    const sellingPlanInput = form.querySelector('[data-selling-plan-input]');
    const purchaseOptions = form.querySelectorAll('input[name="purchase_option"]');

    const selectedVariant = () => picker?.options[picker.selectedIndex];
    const syncPurchaseOption = () => {
      const selected = selectedVariant();
      const selectedPurchase = form.querySelector('input[name="purchase_option"]:checked')?.value || 'one-time';
      const hasSubscription = Boolean(selected?.dataset.sellingPlanId);
      if (subscriptionPlan) subscriptionPlan.hidden = !hasSubscription;
      if (subscriptionPrice) subscriptionPrice.textContent = selected?.dataset.subscriptionPrice || '';
      if (oneTimePrice) oneTimePrice.textContent = selected?.dataset.price || '';
      if (!hasSubscription && selectedPurchase === 'subscription') {
        const oneTime = form.querySelector('input[name="purchase_option"][value="one-time"]');
        if (oneTime) oneTime.checked = true;
      }
      const useSubscription = hasSubscription && form.querySelector('input[name="purchase_option"]:checked')?.value === 'subscription';
      if (sellingPlanInput) {
        sellingPlanInput.value = useSubscription ? selected.dataset.sellingPlanId : '';
        sellingPlanInput.disabled = !useSubscription;
      }
      const displayedPrice = useSubscription ? selected?.dataset.subscriptionPrice : selected?.dataset.price;
      if (price) price.textContent = displayedPrice || selected?.textContent || '';
      if (stickyPrice) stickyPrice.textContent = displayedPrice || selected?.textContent || '';
      if (comparePrice) {
        comparePrice.textContent = selected?.dataset.comparePrice || '';
        comparePrice.hidden = !selected?.dataset.comparePrice;
      }
    };

    picker?.addEventListener('change', () => {
      const selected = selectedVariant();
      if (title) title.textContent = selected.dataset.title || selected.textContent;
      form.querySelectorAll('[data-variant-card]').forEach((card) => {
        const active = card.dataset.variantId === selected.value;
        card.classList.toggle('is-selected', active);
        card.setAttribute('aria-pressed', String(active));
      });
      syncPurchaseOption();
    });
    form.querySelectorAll('[data-variant-card]').forEach((card) => {
      card.addEventListener('click', () => {
        if (card.disabled) return;
        picker.value = card.dataset.variantId;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    purchaseOptions.forEach((option) => option.addEventListener('change', syncPurchaseOption));
    syncPurchaseOption();
  });

  document.querySelectorAll('[data-create-form], form.create-product-form, form.create-catalog-card__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const original = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add this item');
        const cart = await fetch('/cart.js').then((result) => result.json());
        renderDrawer(cart);
        if (drawer) { drawer.hidden = false; document.body.classList.add('cart-drawer-open'); }
        showToast('Added to your bag');
      } catch (error) {
        showToast(error.message || 'Please try again');
      } finally {
        if (button) { button.disabled = false; button.textContent = original; }
      }
    });
  });

  document.querySelectorAll('[data-create-add]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const form = button.closest('[data-product-card]')?.querySelector('form');
      if (form) form.requestSubmit();
    });
  });

  document.querySelectorAll('[data-sticky-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = document.querySelector('form.create-product-form');
      if (form) form.requestSubmit();
    });
  });

  document.querySelectorAll('[data-review-scroll]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('.create-reviews-section');
      const rail = section?.querySelector('[data-review-rail]');
      const card = rail?.querySelector('.create-review-card');
      if (!rail || !card) return;
      const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0);
      const distance = card.getBoundingClientRect().width + gap;
      rail.scrollBy({ left: button.dataset.reviewScroll === 'prev' ? -distance : distance, behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-press-control]').forEach((button) => {
    button.addEventListener('click', () => {
      const id = button.dataset.pressControl;
      document.querySelectorAll('[data-press-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.pressPanel !== id;
      });
      document.querySelectorAll('[data-press-control]').forEach((control) => {
        const active = control === button;
        control.classList.toggle('is-active', active);
        control.setAttribute('aria-selected', String(active));
      });
    });
  });
})();
